import { createSlice } from "@reduxjs/toolkit";
export const SETTING_MAIL_NOTI = "settingMailNoti"

const settingMailNotiSlice = createSlice({
    name: SETTING_MAIL_NOTI,
    initialState: {
        isLoading: false,
        emailNotificationList: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setEmailNotificationList(state, action) {
            state.emailNotificationList = action.payload;
        },
    },
});

export const { setIsLoading, setEmailNotificationList } = settingMailNotiSlice.actions;
export default settingMailNotiSlice.reducer;